import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "../../lib/utils";

const floatingIconButtonVariants = cva(
  "inline-flex items-center justify-center rounded-[4px] transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 shadow-md flex-shrink-0",
  {
    variants: {
      size: {
        sm: "min-w-10 min-h-10 w-10 h-10 [&_svg]:size-6",
        default: "min-w-16 min-h-16 w-16 h-16 [&_svg]:size-10",
        md: "min-w-20 min-h-20 w-20 h-20 [&_svg]:size-[46px]",
        lg: "min-w-24 min-h-24 w-24 h-24 [&_svg]:size-12",
      },
      state: {
        default:
          "bg-white text-[#707070] hover:bg-primary hover:text-primary-foreground",
        active: "bg-primary text-primary-foreground",
      },
    },
    defaultVariants: {
      size: "default",
      state: "default",
    },
  }
);

export interface FloatingIconButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof floatingIconButtonVariants> {
  asChild?: boolean;
}

const FloatingIconButton = React.forwardRef<
  HTMLButtonElement,
  FloatingIconButtonProps
>(({ className, size, state, ...props }, ref) => {
  return (
    <button
      className={cn(floatingIconButtonVariants({ size, state, className }))}
      ref={ref}
      {...props}
    />
  );
});

FloatingIconButton.displayName = "FloatingIconButton";

export { FloatingIconButton, floatingIconButtonVariants };
